import { Component, input, TemplateRef } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  NzSelectModeType,
  NzSelectModule,
  NzSelectSizeType,
} from 'ng-zorro-antd/select';
import { SelectOption } from '../../models/form.model';
import { ControlBase } from '../base/base.component';

@Component({
  imports: [ReactiveFormsModule, NzSelectModule],
  selector: 'control-select',
  template: `
    @if (control()) {
      <nz-select
        [class]="baseClasses"
        [formControl]="control()"
        [nzShowArrow]="true"
        [nzSize]="size()"
        [nzPlaceHolder]="placeholder() || label()"
        [nzMode]="mode()"
        [nzMaxMultipleCount]="maxMultipleCount()"
        [nzBorderless]="borderless()"
        [nzMaxTagCount]="1"
        [nzShowSearch]="true"
        [nzCustomTemplate]="multipleTemplate()"
        [nzMaxTagPlaceholder]="tagPlaceHolder() || defaultTagPlaceHolder"
        [nzDropdownMatchSelectWidth]="false"
        [nzDisabled]="isDisabled()"
      >
        @for (option of options(); track option.value) {
          <nz-option
            [nzValue]="option.value"
            [nzLabel]="option.label"
            [nzDisabled]="option.disabled || false"
          ></nz-option>
        }
      </nz-select>
      <ng-template #defaultTagPlaceHolder let-selectedList>
        <span class="mr-1"> +{{ selectedList.length }} </span>
      </ng-template>
    }
  `,
})
export class ControlSelectComponent extends ControlBase {
  options = input.required<ReadonlyArray<SelectOption>>();
  mode = input<NzSelectModeType>('default');
  maxMultipleCount = input<number>(Infinity);
  size = input<NzSelectSizeType>('default');
  multipleTemplate = input<TemplateRef<any> | null>(null);
  tagPlaceHolder = input<TemplateRef<any> | null>(null);
  borderless = input<boolean>(false);
  isDisabled = input<boolean>(false);
}
